import * as z from "zod";

export const getTags = {
  name: "getTags" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
